'use client';

import { Card, Group, Skeleton, Stack } from '@mantine/core';

export function ProductCardSkeleton() {
  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Card.Section p="md">
        <Skeleton height={140} radius="md" />
      </Card.Section>

      <Stack gap="xs" mt="md">
        <Group gap={4}>
          <Skeleton height={24} width={50} radius="sm" />
          <Skeleton height={24} width={70} radius="sm" />
        </Group>

        <Skeleton height={20} width="80%" radius="sm" />
        <Skeleton height={24} width="60%" radius="sm" />

        <Group gap={4}>
          <Skeleton height={16} width={100} radius="sm" />
        </Group>

        <Group gap={8} wrap="nowrap">
          <Stack gap={4} style={{ flex: 1 }}>
            <Skeleton height={14} width="70%" />
            <Skeleton height={12} width="40%" />
          </Stack>
        </Group>
      </Stack>
    </Card>
  );
}
